import { render, staticRenderFns } from "./RecordTab.vue?vue&type=template&id=54195a68&scoped=true"
import script from "./RecordTab.vue?vue&type=script&lang=js"
export * from "./RecordTab.vue?vue&type=script&lang=js"
import style0 from "./RecordTab.vue?vue&type=style&index=0&id=54195a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54195a68",
  null
  
)

export default component.exports